<template>
  <pill-dropdown
    class="activity-filter"
    label="Activity"
    :options="eventTypes"
    :selected="selected"
    @change="$emit('change', $event)"
  />
</template>

<script>
import PillDropdown from '@/components/board/PillDropdown'
import { EVENT_TYPE_FILTER_OPTIONS } from '@/constants/activity'

export default {
  name: 'ActivityTypeFilter',
  props: ['selected'],
  components: {
    PillDropdown
  },
  data() {
    return {
      eventTypes: EVENT_TYPE_FILTER_OPTIONS
    }
  }
}
</script>

<style lang="scss" scoped></style>
